/**
 * Created by gavorhes on 6/1/2016.
 */
import quickMap from 'webmapsjs/dist/olHelpers/quickMap';
import LayerSwipe from 'webmapsjs/dist/olHelpers/layerSwipe';
import {LayerEsriMapServer, makeServiceUrl, localCacheUrl} from 'webmapsjs/dist/layers/LayerEsriMapServer';
import LayerEsriTile from 'webmapsjs/dist/layers/LayerEsriTile';
import makeGuid from 'webmapsjs/dist/util/makeGuid';
import Map from 'ol/Map'

let minZoomCached = 4;
let maxZoomCached = 8;

import $ = require('jquery');

function urlHelper(service?: string) {
    "use strict";
    service = service || 'compareDynamic';

    return makeServiceUrl('NPMRDS', service)
}

let map: Map = quickMap({minZoom: 6, zoom: 6, center: {x: -9796169, y: 5131676}, fullScreen: true});

let additonalContent = '<label class="slider-label label-2014">2014</label>' +
    '<label class="slider-label label-2015">2015</label>';

let swiper = new LayerSwipe(map, additonalContent);

let $legendLower = $('#legend-lower');


function esriStyleConvert(obj) {
    "use strict";

    let outHtml = '';
    //convert the label

    let labs = obj.label.match(/\d*\.\d*/g);

    /**
     *
     * @type {Array<string>}
     */
    let fixedLabs = [];


    for (let lb of labs) {
        fixedLabs.push(parseFloat(lb).toFixed(2));
    }

    if (fixedLabs[0].indexOf('.00') > -1 && fixedLabs[1].indexOf('.00') > -1) {
        fixedLabs[0] = parseInt(fixedLabs[0]).toFixed();
        fixedLabs[1] = parseInt(fixedLabs[1]).toFixed();
    }

    if (fixedLabs[1] == '9999' || fixedLabs[1] == '9999.00') {
        outHtml += fixedLabs[0] + '&nbsp;+';

        for (let i = 0; i < 3 + fixedLabs[0].length; i++) {
            outHtml += '&nbsp;';
        }
    } else {
        outHtml += fixedLabs.join(' - ');
    }

    outHtml += `<img src="data:${obj.contentType};base64,${obj['imageData']}"/>`;
    outHtml += `<img src="data:${obj.contentType};base64,${obj['imageData']}"/>`;

    return outHtml;
}

interface layerConfig {
    dynamic2014: number;
    dynamic2015: number;
    tile2014: string;
    tile2015: string;
    dynamic2014Other: number;
    dynamic2015Other: number;
    tile2014Other: string;
    tile2015Other: string;
}

let groups = [
    [
        'Observation Percent',
        'Proportion of epochs with available data',
        {
            dynamic2014: 0,
            dynamic2015: 1,
            dynamic2014Other: 12,
            dynamic2015Other: 13,
            tile2014: '2014ObsPrcntTile',
            tile2015: '2015ObsPrcntTile',
            tile2014Other: '2014ObsPrcntTile_NonI',
            tile2015Other: '2015ObsPrcntTile_NonI'
        },
        true
    ],
    [
        'Reliability',
        'Level of travel time reliability (80th/50th)',
        {
            dynamic2014: 2,
            dynamic2015: 3,
            dynamic2014Other: 14,
            dynamic2015Other: 15,
            tile2014: '2014LottrTiles',
            tile2015: '2015LottrTile',
            tile2014Other: '2014LottrTiles_NonI',
            tile2015Other: '2015LottrTile_NonI'
        },
        false
    ],
    [
        'Peak Hour Speed',
        'Metro area peak hour speed (mph)',
        {
            dynamic2014: 4,
            dynamic2015: 5,
            dynamic2014Other: 16,
            dynamic2015Other: 17,
            tile2014: '2014PhSpeedTile',
            tile2015: '2015PhSpeedTile',
            tile2014Other: '2014PhSpeedTile_NonI',
            tile2015Other: '2015PhSpeedTile_NonI'
        },
        false
    ],
    [
        'Truck Reliability',
        'Truck travel time reliability (95th/50th)',
        {
            dynamic2014: 6,
            dynamic2015: 7,
            dynamic2014Other: 18,
            dynamic2015Other: 19,
            tile2014: '2014TruckRelTile',
            tile2015: '2015TruckRelTile',
            tile2014Other: '2014TruckRelTile_NonI',
            tile2015Other: '2015TruckRelTile_NonI'
        },
        false
    ],
    [
        'Truck Speed',
        'Average truck speed (mph)',
        {
            dynamic2014: 8,
            dynamic2015: 9,
            dynamic2014Other: 20,
            dynamic2015Other: 21,
            tile2014: '2014TruckSpeedTile',
            tile2015: '2015TruckSpeedTile',
            tile2014Other: '2014TruckSpeedTile_NonI',
            tile2015Other: '2015TruckSpeedTile_NonI'
        },
        false
    ],
    [
        'Delay',
        'Metro area delay (hours, does not include volume)',
        {
            dynamic2014: 10,
            dynamic2015: 11,
            dynamic2014Other: 22,
            dynamic2015Other: 23,
            tile2014: '2014DelayTile',
            tile2015: '2015DelayTile',
            tile2014Other: '2014DelayTile_NonI',
            tile2015Other: '2015DelayTile_NonI'
        },
        false
    ]
] as Array<[string, string, layerConfig, boolean]>;

let $showInterstates = $('#show-interstates');
let $showOtherRoads = $('#show-other-roads');

$showInterstates.prop('checked', true);
$showOtherRoads.prop('checked', false);

let legendData = '';

export class SwitcherGroup {
    groupInfo: string;
    groupName: string;
    uniqueId: string;
    legendHtml: string;
    _groupVisible: boolean;
    dynamic2014: LayerEsriMapServer;
    dynamic2015: LayerEsriMapServer;
    tile2014: LayerEsriMapServer;
    tile2015: LayerEsriMapServer;
    dynamic2014Other: LayerEsriMapServer;
    dynamic2015Other: LayerEsriMapServer;
    tile2014Other: LayerEsriMapServer;
    tile2015Other: LayerEsriMapServer;
    npmrdsService: string;


    /**
     *
     * @param {string} name
     * @param {string} info
     * @param {object} lyrs
     * @param {number} lyrs.dynamic2014
     * @param {number} lyrs.dynamic2015
     * @param {string} lyrs.tile2014
     * @param {string} lyrs.tile2015
     * @param {number} lyrs.dynamic2014Other
     * @param {number} lyrs.dynamic2015Other
     * @param {string} lyrs.tile2014Other
     * @param {string} lyrs.tile2015Other
     * @param {boolean} [visible=false]
     * @param {string} npmrdsService
     */
    constructor(name: string,
                info: string,
                lyrs: layerConfig,
                visible: boolean,
                npmrdsService: string) {

        this.groupName = name;
        this.groupInfo = info;
        this.uniqueId = makeGuid();
        this.legendHtml = '';
        this.npmrdsService = npmrdsService;

        visible = typeof visible == 'boolean' && visible;

        this._groupVisible = visible;

        this.dynamic2014 = new LayerEsriMapServer(
            urlHelper(this.npmrdsService),
            {
                minZoom: 12,
                visible: visible,
                showLayers: [lyrs.dynamic2014],
                zIndex: 2,
                getLegend: false
            });


        this.dynamic2015 = new LayerEsriMapServer(
            urlHelper(this.npmrdsService),
            {
                minZoom: maxZoomCached + 1,
                visible: visible,
                showLayers: [lyrs.dynamic2015],
                zIndex: 2,
                getLegend: false
            });



        this.tile2014 = new LayerEsriMapServer(
            localCacheUrl('NPMRDS', 'compareDynamic'),
            {
                minZoom: minZoomCached,
                maxZoom: maxZoomCached,
                showLayers: [lyrs.dynamic2014],
                visible: visible,
                name: lyrs.tile2014,
                getLegend: false,
                zIndex: 2,
            });


        this.tile2015 = new LayerEsriMapServer(
            localCacheUrl('NPMRDS', 'compareDynamic'),
            {
                minZoom: minZoomCached,
                maxZoom: maxZoomCached,
                showLayers: [lyrs.dynamic2015],
                visible: visible,
                name: lyrs.tile2015,
                getLegend: false,
                zIndex: 2
            });

        this.dynamic2014Other = new LayerEsriMapServer(
            urlHelper(this.npmrdsService),
            {
                minZoom: maxZoomCached + 1,
                visible: false,
                showLayers: [lyrs.dynamic2014Other],
                zIndex: 1,
                getLegend: false
            });


        this.dynamic2015Other = new LayerEsriMapServer(
            urlHelper(this.npmrdsService),
            {
                minZoom: maxZoomCached + 1,
                visible: false,
                showLayers: [lyrs.dynamic2015Other],
                zIndex: 1,
                getLegend: false
            });



        this.tile2014Other = new LayerEsriMapServer(
            localCacheUrl('NPMRDS', 'compareDynamic'),
            {
                minZoom: minZoomCached,
                maxZoom: maxZoomCached,
                showLayers: [lyrs.dynamic2014Other],
                visible: false,
                name: lyrs.tile2014Other,
                getLegend: false,
                zIndex: 1
            });

        this.tile2015Other = new LayerEsriMapServer(
            localCacheUrl('NPMRDS', 'compareDynamic'),
            {
                minZoom: minZoomCached,
                maxZoom: maxZoomCached,
                showLayers: [lyrs.dynamic2015Other],
                visible: false,
                name: lyrs.tile2015Other,
                getLegend: false,
                zIndex: 1
            });



        if (legendData) {
            this.makeLegendHtml(legendData, lyrs.dynamic2015)
        } else {
            $.get(urlHelper(this.npmrdsService) + '/legend', {f: 'pjson'}, (d) => {
                legendData = d;
                this.makeLegendHtml(legendData, lyrs.dynamic2015)

            }, 'json');
        }


        map.addLayer(this.dynamic2014.olLayer);
        map.addLayer(this.dynamic2015.olLayer);
        map.addLayer(this.tile2014.olLayer);
        map.addLayer(this.tile2015.olLayer);

        map.addLayer(this.dynamic2014Other.olLayer);
        map.addLayer(this.dynamic2015Other.olLayer);
        map.addLayer(this.tile2014Other.olLayer);
        map.addLayer(this.tile2015Other.olLayer);


        swiper.addLeftLayer(this.dynamic2014);
        swiper.addLeftLayer(this.tile2014);
        swiper.addRightLayer(this.dynamic2015);
        swiper.addRightLayer(this.tile2015);

        swiper.addLeftLayer(this.dynamic2014Other);
        swiper.addLeftLayer(this.tile2014Other);
        swiper.addRightLayer(this.dynamic2015Other);
        swiper.addRightLayer(this.tile2015Other);
    }

    get visible() {
        return this._groupVisible;
    }

    set visible(viz) {
        if (this._groupVisible == viz) {
            return;
        }
        this._groupVisible = viz;

        this.updateLayerVisibility();

        if (this.visible) {
            $legendLower.html(this.legendHtml);
        }
    }

    makeLegendHtml(leg: Object, lyr: number) {

                let legendItems = leg['layers'][lyr]['legend'];
                this.legendHtml = `<p>${this.groupInfo}</p>`;
                this.legendHtml += '<ul>';
                for (let itm of legendItems) {
                    this.legendHtml += `<li>${esriStyleConvert(itm)}</li>`;
                }
                this.legendHtml += '</ul>';

                if (this.visible) {
                    $legendLower.html(this.legendHtml);
                }

    }

    get radioHtml() {
        let returnHtml = '';
        returnHtml += `<input type="radio" id="${this.uniqueId}" ${this.visible ? 'checked' : ''} name="metrics"/>`;
        returnHtml += `<label for="${this.uniqueId}">${this.groupName}</label>`;
        return returnHtml;
    }

    updateLayerVisibility() {
        let interstateChecked = $showInterstates.prop('checked');
        let otherChecked = $showOtherRoads.prop('checked');

        this.dynamic2014.visible = interstateChecked && this.visible;
        this.dynamic2015.visible = interstateChecked && this.visible;
        this.tile2014.visible = interstateChecked && this.visible;
        this.tile2015.visible = interstateChecked && this.visible;

        this.dynamic2014Other.visible = otherChecked && this.visible;
        this.dynamic2015Other.visible = otherChecked && this.visible;
        this.tile2014Other.visible = otherChecked && this.visible;
        this.tile2015Other.visible = otherChecked && this.visible;
    }
}


let urbanAreas = new LayerEsriMapServer(
    makeServiceUrl('NPMRDS', 'urbanized_areas'),
    {
        minZoom: 5,
        visible: true,
        name: 'Urban Areas',
        opacity: 0.5,
        getLegend: false
    });

map.addLayer(urbanAreas.olLayer);


let $groupList = $('#group-list');

/**
 *
 * @type {Array<SwitcherGroup>}
 */
let groupArray = [];


/**
 *
 * @type {{}<string, SwitcherGroup>}
 */
let groupLookup = {};


for (let g of groups) {
    let grp = new SwitcherGroup(g[0], g[1], g[2], g[3], 'compareDynamic');
    groupArray.push(grp);
    groupLookup[grp.uniqueId] = grp;
    $groupList.append(`<li>${grp.radioHtml}</li>`);
}

function setGroup(groupId) {
    "use strict";
    for (let g of groupArray) {
        g.visible = g.uniqueId == groupId;
    }
}


$groupList.find('input').change(function (evt) {
    "use strict";
    setGroup(this.id);
});

$('#legend-show-hide').click(function () {
    "use strict";

    $legendLower.slideToggle();
    $(this).toggleClass('flipped');
});


$showInterstates.change(() => {
    "use strict";
    for (let g of groupArray) {
        g.updateLayerVisibility();
    }
});

$showOtherRoads.change(() => {
    "use strict";
    for (let g of groupArray) {
        g.updateLayerVisibility();
    }
});

